import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";

export class ActivateGoldenMultiplier implements SimplePresentation {

    shouldRun(): boolean {
        return FlightMode.model.goldenMultiplierPositions().length > 0;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const jetFuelSymbols = FlightMode.model.goldenMultiplierPositions();
        const tl = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)})
        })

        jetFuelSymbols.forEach((sym) => {
            const reel = sym.reel;
            const row = sym.row;

            tl.add(FlightMode.reelView.moveUpSymbolAt(reel, row), '>0.2');
            tl.add(FlightMode.reelView.getSymbolAt(reel, row).goldenMultiplierReveal(), '<');
            tl.add(FlightMode.reelView.doubleMultiplierCounter(), '<0.3');
            tl.add(FlightMode.reelView.moveDownSymbolAt(reel, row));
        })

        tl.add(() => {
            controller.finish();
        });
    }
}